var React = require('react');

function Ionic (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m73.829 12.788c0 1.407-0.5213 2.7-1.377 3.675 5.0504 6.697 8.0484 15.023 8.0484 24.037 0 22.056-17.944 40-40 40s-40-17.944-40-40 17.944-40 40-40c9.014 0 17.34 2.998 24.037 8.0488 0.986-0.8556 2.268-1.3765 3.6756-1.3765 3.1012 0 5.6166 2.5136 5.6166 5.6156zm-33.329 66.366c21.314 0 38.654-17.341 38.653-38.655 0-8.6673-2.8672-16.676-7.7024-23.13-0.9163 0.6487-2.0314 1.0333-3.2397 1.0333-3.101 0-5.6157-2.5137-5.6157-5.6152 0-1.2078 0.3846-2.3243 1.0332-3.24-6.454-4.8352-14.462-7.7024-23.129-7.7024-21.314 0-38.655 17.341-38.655 38.655s17.341 38.654 38.655 38.654zm4e-4 -22.323c-9.0196 0-16.332-7.3118-16.332-16.331s7.312-16.332 16.332-16.332 16.332 7.312 16.332 16.332-7.3118 16.33-16.332 16.33z","fill":"#4e8ef7","stroke":"none"}));
}

Ionic.defaultProps = {"className":"tag-icon","width":"128","height":"128","viewBox":"0 0 82 82"};

module.exports = Ionic;

Ionic.default = Ionic;
